
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

import BaseBackIcon from '@/components/BaseBackIcon.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { BaseBackIcon, LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()

    return {
      t,
      appName: process.env.VUE_APP_APP_NAME
    }
  },
})
